import { createFileRoute } from '@tanstack/react-router';

import { LeagueForm } from '../-components/LeagueForm';

export const Route = createFileRoute('/_authenticated/teams/leaguesAndTournaments/new')({
    component: LeagueForm,
});
